import styled from 'styled-components';
import { AssetsFileResolver } from 'app-modules/application/containers/AssetsFileResolver';

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
  justify-content: center;
  left: 0;
  position: absolute;
  top: 0;
  z-index: 2000;
  opacity: ${(props) => (props.visible ? 1 : 0)};
  transition: opacity 0.2s ease-in;
  background-color: #000;
`;

const ProgressWrapper = styled.div`
  margin-top: 30px;

  &.siteWideLogo {
    margin-top: 18px;

    @media (min-width: 1024px) {
      margin-top: 44px;
    }
  }
`;

const PlutoProgressBar = styled(AssetsFileResolver)`
  margin-left: 20px;
  width: 600px;
  max-width: 90vw;

  &.siteWideLogo {
    margin-left: 0;
    width: 340px;

    @media (min-width: 1024px) {
      width: 705px;
      height: 31.75px;
    }
  }
`;

// actual Logo dimensions are 79x16
const PlutoLogo = styled(AssetsFileResolver)`
  width: 260px;
  height: ${(260 / 79) * 16}px;
`;

const LogoText = styled.div`
  font-family: 'Pluto Sans Semibold';
  font-size: 20px;
  color: #ffde2b;
  margin-top: 10px;

  @media (min-width: 1024px) {
    font-size: 45px;
  }
`;

const SvgLogo = styled.div`
  svg {
    width: 250px;
    @media (min-width: 1024px) {
      width: 525px;
    }
  }
`;

export { Wrapper, ProgressWrapper, PlutoLogo, PlutoProgressBar, LogoText, SvgLogo };
